import { energyAnalysisApiSlice } from '../apiSlice';

export const energyDataApiSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEnergyData: builder.query({
      query: (args) => {
        const {
          accountId,
          energyGroupId,
          start,
          end,
          activeHoursFilter,
          activeDaysFilter,
          activeHolidaysFilter,
        } = args;

        const params = new URLSearchParams({
          start_timestamp: new Date(start).toISOString(),
          end_timestamp: new Date(end + 1).toISOString(),
        });

        if (activeHoursFilter !== undefined) {
          params.append('active_hours_filter', activeHoursFilter.toString());
        }
        if (activeDaysFilter !== undefined) {
          params.append('active_days_filter', activeDaysFilter.toString());
        }
        if (activeHolidaysFilter !== undefined) {
          params.append('holidays_filter', activeHolidaysFilter.toString());
        }

        const url = `/energy_data/${accountId}/${energyGroupId}?${params.toString()}`;

        return { url };
      },
      providesTags: ['EnergyData'],
    }),
    getTimestampSummary: builder.query({
      query: (args) => {
        const { accountId, energyGroupId } = args;

        const url = `/energy_timestamps_summary/${accountId}/${energyGroupId}`;

        return { url };
      },
      providesTags: ['EnergyData'],
    }),
  }),
});

export const {
  useGetEnergyDataQuery,
  useLazyGetEnergyDataQuery,
  useGetTimestampSummaryQuery,
} = energyDataApiSlice;
